
import React, { Fragment } from 'react';
import { useEffect, useState, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import './ProfileInformation.scss';
import Icon from '@mdi/react';
import { mdiPencil, mdiCreditCardEdit } from '@mdi/js';
import { mdiArrowLeft, mdiEmailMarkAsUnread, mdiClose } from '@mdi/js';
import { Link, useNavigate, NavLink, useLocation, withRouter } from 'react-router-dom';

import agent from '../../agent';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Helmet } from "react-helmet";
import Select, { NonceProvider, components } from 'react-select'
// import AsyncSelect from 'react-select/async';
import axios from "axios";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import Modal from 'react-modal';
import { HANDLE_401_ERROR, PROFILE_INFORMATION_LOAD } from '../../constants/actionTypes';
import { isEditable } from '@testing-library/user-event/dist/utils';
// import Stripe from 'stripe';
import { APP_LOAD, USER_LOAD } from '../../constants/actionTypes';
import dropdownicon from "../ProfileMenu/images/dropdownicon.png";
import Footer from '../../components/Footer/Footer';
// import { Link,  } from 'react-router-dom';



const mapStateToProps = state => ({ ...state });


const mapDispatchToProps = dispatch => ({
  onLoad: (payload, setData) => {
    dispatch({ type: USER_LOAD, payload, skipTracking: true });
  }
});

const ProfileInfo = (props) => {

  const location = useLocation();
 // console.log("Location on profile screen", location);
 // console.log("props on profile information", props);

  const [isLoading, setLoading] = useState(true);
  const [editState, setEditState] = useState(true);
  const [editValidation, setEditValidation] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileInfoError, setProfileInfoError] = useState("");
  const [profileInfoSuccess, setProfileInfoSuccess] = useState("");

  // Zip code
  const [zipCode, setZipCode] = useState('');
  const [emailVeify, setEmailVerify] = useState(false);
  const [cityName, setCityName] = useState('');
  // const [zipCodeServiceCheck, setZipCodeServiceCheck] = useState("");
  // const [zipCodeServiceData, setZipCodeServiceData] = useState("");

  // Card Info
  const [stripeApiKey, setStripeApiKey] = useState("");
  const [cardAddPopup, setCardAddPopup] = React.useState(true);
  const [paymentToken, setPaymentToken] = useState("");
  const [editIsOpen, setEditIsOpen] = useState(false);

  // ProfileInfo
  const [data, setData] = useState('');
  const [bikeTypeList, setBikeTypeList] = useState([]);
  const [bikeTypeOptions, setBikeTypeOptions] = useState([]);
  // console.log("bike-list",data.results?.vehicle_info?.type.display_name)
  const [bikeTypes, setBikeTypes] = useState('');
  const [bikeTypeId, setBikeTypeId] = useState('');
  const [bikeMakeList, setBikeMakeList] = useState([]);
  const [bikeMakes, setBikeMakes] = useState('');
  const [bikesGearId, setBikesGearId] = useState('');
  const [bikesMakeId, setBikesMakeId] = useState('');
  const [bikesTypeId, setBikesTypeId] = useState('');
  // const [bikeMakeId, setBikeMakeId] = useState('');
  const [bikeModelList, setBikeModelList] = useState([]);
  const [bikeModels, setBikeModels] = useState('');
  // const [bikeModelId, setBikeModelId] = useState('');
  const [bikesModelId, setBikesModelId] = useState('');
  // const [zipCodeServiceCheck, setZipCodeServiceCheck] = useState('');

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [cardFieldEmpty, setCardFieldEmpty] = useState('');
  const [zipcodePopUp, setZipcodePopUp] = useState(false);
  const [updateModelIsOpen, setUpdateModelIsOpen] = useState(false);
  //console.log("zipError?.message", zipError);
  const [inputValueChanges, setInputValueChanges] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState('');



  useEffect(() => {
    bikeInfo();
    bikeMakeInfo();
    bikeModelInfo();
    getProfileInfo();
    // props.onLoad(agent.Auth.current());

    // setIsOpen(false);
  }, [modalIsOpen]);

  // useEffect(() => {
  //   // props.onLoad(agent.Auth.save(data));
  //   props.onLoad(agent.Auth.current());

  // }, [data])


  useEffect(() => {
    if (bikeTypes) {
      bikeMakeInfo(bikeTypes);
    }
    if (bikeMakes) {
      bikeModelInfo(bikeMakes);
    }
  }, [bikeTypes, bikeMakes]);






  // form validation rules 
  const phoneRegExp = /^(\+?[0-9]{1,3}[\s\-\.]?)?(\([0-9]{3}\)|[0-9]{3})[\s\-\.]?[\0-9]{3}[\s\-\.]?[0-9]{4}$/


  const validationSchema = Yup.object({
    first_name: Yup.string('First name should be string value')
      .required('First name is required.')
      .nullable()
      // .matches(/^\S*$/, 'First name should not start with a space.')
      .matches(/^[a-zA-Z]+$/, 'The First name cannot contain White space and Special characters.')
      .min(3, 'First name should be at least 3 characters long.')
      .max(64, 'First name should not exceed 64 characters.'),
    last_name: Yup.string()
      .required('Last name is required')
      .nullable()
      .matches(/^[a-zA-Z]+$/, 'The Last name cannot contain White space and Special characters.')
      .min(1, 'Last name should be at least single character.')
      .max(64, 'Last name should not exceed 64 characters.'),
    // emailid: Yup.string().required('Last name is required').min(1).max(64),
    notification_email: Yup.string().required('Email ID is required').min(1).matches(/^[A-Za-z0-9][A-Za-z0-9._%+-]*@[A-Za-z]{3,}(\.[A-Za-z]{2,}|\.[A-Za-z]{2,}\.[A-Za-z]{2,})$/, 'Please enter valid email'),
    mobile: Yup.string()
      .required('Mobile number is required')
      // .matches(/^\S*$/, 'Phone number should not start with whitespaces.')
      .matches(phoneRegExp, 'Phone number is not valid')
      .nullable(),
      // .min(10, "Phone number is not valid")
      // .max(10, "Phone number is not valid"),
    address: Yup.string()
      .required('Address is required')
      .nullable()
      .matches(/^\S.*\S$/, 'Address should not start or end with whitespaces.')
      .min(6, 'Address should be at least six characters long')
      .max(256, 'Address should not exceed 256 characters.'),
    city: Yup.string()
      .nullable(),
    state: Yup.string()
      .nullable(),
    zip_code: Yup.string()
      .matches(/^[\S]*$/, 'Zip code cannot contain whitespace.')
      .nullable()
      .matches(/^\d{5}(?:[-]\d{4})?$/, 'Invalid zip code format.'),

    // zipcode: Yup.string().required("Zip Code is required.").matches(/^[0-9]+$/, "Zip Code Must be only digits"),
    biketype: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable('Field cannot be empty')
      .required('This field is required.'),
    bikemake: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable('Field cannot be empty')
      .required('This field is required.'),
    bikemodel: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable('Field cannot be empty')
      .required('This field is required.'),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema)
  };
  const { register, setValue, control, handleSubmit, trigger, watch, formState: { errors } } = useForm(formOptions);


  const cardAddPopupClose = () => {
    setCardAddPopup(false);
    refreshPage();
  }

  function refreshPage() {
    window.location.reload(false);
  }



  const getProfileInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
   // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      //console.log("Configuration", config)
      const response = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'user', config);
      //console.log("DATA",data)
     // console.log("DATA", response?.data)
      // console.log("email ver", response?.data?.results?.email_verified);
      // console.log('id', response?.data?.results?._id)
      setEmailVerify(response?.data?.results?.email_verified);

      setValue('id', response?.data?.results?._id);
      setValue('first_name', response?.data?.results?.first_name);
      setValue('last_name', response?.data?.results?.last_name);
      setValue('email', response?.data?.results?.email);
      setValue('notification_email', response?.data?.results?.notification_email)
      setValue('address', response?.data?.results?.address?.address);
      setValue('zip_code', response?.data?.results.address?.zipcode);
      setValue('mobile', response?.data?.results?.mobile);
      setValue('city', response?.data?.results?.address?.city);
      setValue('state', response?.data?.results?.address?.state);
      setData(response?.data)

      // document.getElementById('email').attributes('disabled', true);
      if (response?.data?.results?.vehicle_gear) {
        let { vehicle_info } = response?.data?.results;
        let _bikeTypeList = [response?.data?.results?.vehicle_type];
        let _bikeMakeList = [response?.data?.results?.vehicle_make];
        let _bikeModelList = [response?.data?.results?.vehicle_gear];

        //setBikeTypeList(_bikeTypeList);

        let selectedBikeType = _bikeTypeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeTypeList", _bikeTypeList)
        // console.log("selectedBikeType", selectedBikeType)
        //setBikeTypes(selectedBikeType[0])

        setValue('biketype', selectedBikeType[0])

        /////////////////////////////////
        // _bikeMakeList.push({ _id: 1, display_name: 'select' })
        // setBikeMakeList(_bikeMakeList);

        let selectedBikeMake = _bikeMakeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeMakeList", _bikeMakeList)
        // console.log("selectedBikeMake", selectedBikeMake)
        //setBikesGearId(selectedBikeMake[0])
        setValue('bikemake', selectedBikeMake[0])

        // setBikeModelList(_bikeModelList);

        let selectedBikeModel = _bikeModelList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeModelList", _bikeModelList)
        // console.log("selectedBikeModel", selectedBikeModel)
        // setBikeModels(selectedBikeModel[0])
        setValue('bikemodel', selectedBikeModel[0])
        setBikesModelId(selectedBikeModel[0].value)
        // const [types, makes, models] = await Promise.all([
        //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/type', config),
        //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/make', config),
        //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/model', config)
        // ]);
        // setVehicleTypes(types.data)
        // setVehicleMakes(makes.data)
        // setVehicleModels(models.data)
        setLoading(false)
       // console.log(data)
      }

      setLoading(false);

    } catch (error) {
      setLoading(false)
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
    }
  };

  // const customStylesSelect = {
  //   control: (provided) => ({
  //     ...provided,
  //     '&:hover': {
  //       border: '1px solid #FF5F07',
  //     },
  //     '&:focus': {
  //       border: '1px solid #FF5F07',
  //     },
  //   }),
  // };
  // console.log("bikedata", bikesModelId);

  let userId = data?.results?._id
  // console.log("user-id", userId);
  // Dev test stripe
  const stripePromise = loadStripe(process.env.REACT_APP_RIDEDOC_STRIPE);
  //const stripePromise = loadStripe("pk_test_51LRHoXIYZnjmRvNrhICrNc74ThoumufDMGh4tQ3mpSJNbSkm7thjn5IB7puGO8MyWzXsZ8kYL1KMZlVBHBKrBFye00ZypeIIOw"); //testURL
  //Prod test stripe
  //const stripePromise = loadStripe("pk_test_51NJg7pF1zaSfTTYmt2WxK1zC40cx0qjiRR3DgL6ZFIlShFIOBjicQVJDdftBuJAUESs0Wwwsrxv1ZsoUBrWp453B00FiuwIHXn");
  // Prod live stripe
  // const stripePromise = loadStripe("pk_live_51NJg7pF1zaSfTTYmpK07mIRmntL1vLfcj7jMfJQpYX3eEjWPm7lWIQmItSYvw5DfPJdoKUb4N6S6FzbD652uUmFN00GvxUT0c9"); //ProdURL

  const getStripeApiKey = async () => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const val = {
        stripe_user_id: data?.results?.stripe_user_id
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + 'payment/setup-intent', val, config);
     // console.log(" STRIPE RESPONSE", response);

      setStripeApiKey(response?.data?.results?.client_secret);
    } catch (error) {
     // console.log(error)
      HANDLE_401_ERROR(error.response?.status);
    }
  };

  // const collectPaymentMethod = async () => {
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   const stripe = new Stripe(stripeApiKey);

  //   try {

  //     const result = await stripe.paymentMethods.collect({
  //       payment_method: 'pm_setupintent_1234',
  //     });
  //     console.log(" STRIPE RESPONSE", result);


  //   } catch (error) {
  //     console.log(error)
  //   }
  // };



  const bikeInfo = async () => {
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/type', config);
      // console.log("data of bikes", data);
      setBikeTypeOptions(data.results);
      // console.log("bikelist", bikeTypeList)
    } catch (error) {
     // console.log(error);
    }
  };

  const bikeMakeInfo = async (bikeTypes) => {
    // console.log("inside bikemake", bikeTypes);
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make', config);
      setBikeMakeList(data.results);

     // console.log("vehicleMake", bikeMakeList)
    } catch (error) {

    }
  }

  const bikeModelInfo = async (bikeMakes) => {
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/gear', config);
      setBikeModelList(data.results)
      // setBikesModelId(data.value);
      // console.log("vehicleModel", bikeModelList)
    } catch (error) {

    }
  }
  // console.log("model_id", bikesModelId);

  const handleBikeValueChange = (selectedOption) => {
    // console.log("handleBikeValueChange", selectedOption)
    setBikeTypes(selectedOption);
  }

  // const handleResetOptions = (event) => {
  //   setValue('bikemodel', '');
  //   setValue('bikemake', '');
  // }

  const handleResetOptions = (selectedOption, selectedValue) => {
    if (selectedOption.value !== selectedValue) {
      // setValue('bikemodel', '');
      // setValue('bikemake', '');
    }
  };
  // const handleModelReset = (event) => {
  //   setValue('bikemodel', '');
  // }

  const handleModelReset = (selectedOption, selectedValue) => {
    if (selectedOption.value !== selectedValue) {
      // setValue('bikemodel', '');
    }
  };


  const convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        value: item.value, label: item.label
      };
    }, initialValue);
  };


  // useEffect(() => {
  //   getProfileInfo();

  //   setCardAddPopup(true)
  // }, []);



  // let country = data?.address?.country;

  // console.log("user data", data);


  // console.log("bike type", bikeTypes);
  // console.log("bike make", bikeMakes);
  // console.log("bike model", bikeModels);

  // let bikemake = data?.vehicle_info?.make;
  // let bikemodel = data?.vehicle_info?.model;
  // let biketype = data?.vehicle_info?.type;
  // let isEmailVerified = data?.address?.email_verified;
  // console.log("IsEmail", emailVeify);
  // console.log("IsEmail", isEmailVerified);
  let paymentMethods = data.payment_methods ? data.payment_methods : [];

  // console.log("Profile Info scucces", profileInfoSuccess);

  // if (profileInfoSuccess) {
  //   getStripeApiKey();
  // }

  // if (stripeApiKey) {
  //   collectPaymentMethod(stripeApiKey);
  // }


  // let zipCodeServiceCheck = '';



  // let modelOptions = [];
  // let typeOptions = [];
  // let makeOptions = [];
  // let makeOptionsDefaultVal = {};
  // let modelOptionsDefaultVal = {};
  // let typeOptionsDefaultVal = {};

  // if(vehicleMakes) {
  //   let vehicleData = vehicleMakes;
  //   makeOptions = vehicleData.map(({ name, display_name }) => ({value: name, label: display_name}));
  //   makeOptionsDefaultVal = convertArrayToObject(makeOptions.filter(option => option.value === bikemake));
  // }
  // if(vehicleTypes) {
  //   let vehicleData = vehicleTypes;
  //   typeOptions = vehicleData.map(({ name, display_name }) => ({value: name, label: display_name}));
  //   typeOptionsDefaultVal = convertArrayToObject(typeOptions.filter(option => option.value === biketype));
  // }
  // if(vehicleModels) {
  //   let vehicleData = vehicleModels;
  //   modelOptions = vehicleData.map(({ name, display_name }) => ({value: name, label: display_name}));
  //   modelOptionsDefaultVal = convertArrayToObject(modelOptions.filter(option => option.value === bikemodel));
  // }

  const onChangeZipCode = async (value) => {
    let newZipCode = value.target.value;
    if (newZipCode.length !== 5 || isNaN(newZipCode)) {
      setValue('city', '');
      setValue('state', '');
      //setZipcodePopUp(true);
      return;
    } else {
      // setLoading(true)

      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            'x-access-token': `${accessToken}`,
            'x-request-time': new Date().toString(),
            'x-request-timezone': timeZone
          },
        };
        const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `/zip-county/zipcode/${newZipCode}`, config);

        // setLoading(false);
        setValue('city', data?.results[0].city);
        setValue('state', data?.results[0].state);

        // let cityName = setCityName(data.results[0].city);
        // console.log("CITY", cityName)

      } catch (error) {
        setZipcodePopUp(true);
        HANDLE_401_ERROR(error.response?.status);
        // setCityName('');
      // console.log(error);
        // if(error.response.data.service_available == false) {
        //   setZipCodeServiceCheck('Please enter available zip code');
        // }
      }
    }
  }

 // console.log("data value", data);

  const onSubmit = async (formData) => {
    if (data?.results?.card === null) {
      // alert('ji');
      setCardFieldEmpty("Add card details");
    } else {
      // alert('si');
      setCardFieldEmpty('');
      setLoading(true);

     // console.log("form_data", formData)
      // console.log("bike_id", formData.bikeModelId);
      // console.log("user-id", userId);
      let val = {
        // lastName: formData.last_name,
        // firstName: formData.first_name,
        mobile: formData.mobile,
        first_name: formData.first_name,
        last_name: formData.last_name,
        notification_email: formData.notification_email,
        address: {

          address: formData.address,
          city: formData.city,
          state: formData.state,
          country: 'US',
          zipcode: formData.zip_code,
        },
        // card: {
        //   "token": {
        //     "bankAccount": null,
        //     "card": [
        //       paymentToken?.token?.card ? paymentToken?.token?.card : null,
        //     ],
        //     "created": paymentToken?.token?.created ? paymentToken?.token?.created : null,
        //     "id": paymentToken?.token?.id ? paymentToken?.token?.id : null,
        //     "livemode": paymentToken?.token?.livemode ? paymentToken?.token?.livemode : null,
        //     "type": paymentToken?.token?.type ? paymentToken?.token?.type : null,
        //     "used": false,
        //   },

        // },

        vehicle_gear: bikesGearId,
        vehicle_type: bikesTypeId,
        vehicle_make: bikesMakeId
      }
      // console.log("bike_model",data.bikemodel.value)



      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            'x-access-token': `${accessToken}`,
            'x-request-time': new Date().toString(),
            'x-request-timezone': timeZone
          },
        };

        const response = await axios.patch(process.env.REACT_APP_RIDEDOC_API_ROOT + `user/` + formData.id,
          val,
          config
        );

        // function onLoad(response) {
        //   dispatch({ type: USER_LOAD, response, skipTracking: true });

        // }
        setLoading(false);
       // console.log("USER PATCH DATA", response);
        setData(response?.data);



        // setProfileInfoSuccess(response.message)
        setProfileInfoSuccess(response?.data?.message);
        if(response?.data?.message){
          setUpdateModelIsOpen(true);
        } else {
          setUpdateModelIsOpen(false);
        }
        getStripeApiKey();

        if (response?.data?.results?.card?.id) {
          return
        }
        else {
          setIsOpen(true);

          //  if (!(paymentMethods.length > 0)) {
          //   setIsOpen(true)
          // }

        }
      } catch (error) {
        setLoading(false)
        HANDLE_401_ERROR(error.response?.status);
       // console.log(" profile submit-errors", error);
        // setProfileInfoError(error.response.data.message)
        // setProfileInfoError(error.response.message)
      }
    }
  };
  // console.log("profile-success", profileInfoSuccess);
  // console.log("profile-success", profileInfoSuccess);


  const customStyles = {
    content: {
      top: '45%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '20px 15px',
      width: '90%'
    },
  };
  const CaretDownIcon = () => {
    return <img className="fas fa-caret-down" src={dropdownicon} alt='No Image' />;
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{ width: "0px !important" }} {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };
  function closeModal() {
    setIsOpen(false);

  }

  function closeModelZipcode() {
    setZipcodePopUp(false)
  }

  function closeEditModal() {
    setEditIsOpen(false);

  }

  // console.log("bikelist", bikeTypeList);

  function handleInputChange(value, label) {
    setBikeModels(value);
    setBikesModelId(value.value);
  }

  const handleSaveButtonClick = () => {
    // Simulating saving the profile
    setUpdateModelIsOpen(true);
  };

  const handleCloseModal = () => {
    setUpdateModelIsOpen(false);
  };
  
  const handleLeaveButtonClick = () => {
    setShowUnsavedModal(false); // Close the modal
    
    if (pendingNavigation === 'home') {
      navigate('/home'); // Navigate to home screen
    } else if (pendingNavigation === 'profile') {
      navigate('/profile'); // Navigate to profile screen
    } else if (pendingNavigation === 'orders') {
       navigate('/order-history')
    }
    // } else if (location?.state?.From === 'service') {
    //   navigate('/services' + location.pathname, {
    //     state: {
    //       plans: location?.state?.item?.plans,
    //       UserData: data,
    //       plans_title: location?.state?.item?.plans_title,
    //       service: location?.state?.item?.service,
    //       service_id: location?.state?.item?.service_id,
    //       userAddres: location?.state?.item?.userAddres,
    //     },
    //   });
    // } 
      setPendingNavigation(null);
 
  };

  const handleUpdateButton = () => {
    if(location?.state?.From == 'servcie'){
      navigate('/services'+location.pathname,{
        state:{plans:location?.state?.item?.plans,
        UserData:data,
        plans_title:location?.state?.item?.plans_title,
        service:location?.state?.item?.service,
        service_id:location?.state?.item?.service_id,
        userAddres:location?.state?.item?.userAddres
      }})
    }else{
    navigate('/profile');
  }
};

  const handleChange = () => {
    setInputValueChanges(true);
  };

  const handleIconClick = (iconName) => {
    if (inputValueChanges) {
      setShowUnsavedModal(true);
      setPendingNavigation(iconName);
    } else {
      if (location?.state?.From === 'service') {
        navigate('/services' + location.pathname, {
          state: {
            plans: location?.state?.item?.plans,
            UserData: data,
            plans_title: location?.state?.item?.plans_title,
            service: location?.state?.item?.service,
            service_id: location?.state?.item?.service_id,
            userAddres: location?.state?.item?.userAddres,
          },
        });
      } else {
        if (iconName === 'profile') {
          navigate('/profile'); // Navigate to profile screen directly
        } else if (iconName === 'home') {
          navigate('/home'); // Navigate to home screen directly
        } else if (iconName === 'orders') {
          navigate('/order-history')
        }
      }
    }
  };
  

  const handleUnsavedClose = () => {
     setShowUnsavedModal(false);
  }
  const handlecard =(data)=>{
   // console.log("card data",data);
    setInputValueChanges(data);
  }
  const handleCardEdit = () => {
    setEditIsOpen(true);
  }


  const profileMenuBackground = require('../ProfileMenu/images/profile-menu-background.png');


  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <>
      <div className='profile-bg-background'>
        <div className='main'>
          <Helmet>
            <title>RideDoc | Profile Information</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>

          <div className='header-wrp'>
            <header className='header-lft'>
              <div className="header-backic">
                <button onClick={() => handleIconClick('profile')} className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </button>
              </div>
              <div className='profile-information-header-text'>
                <p>Profile Information</p>
              </div>
            </header>
          </div>
          <div className='main-wrapper booking-wrp'>
            {emailVeify ?
              <div className="profile-info-wrp">
                <section className="profile-info-sec-wrp">

                  {profileInfoError && <span className='error'>{profileInfoError}</span>}
                  {/* {profileInfoSuccess && <span className='success'>{profileInfoSuccess}</span>} */}

                  <form onSubmit={handleSubmit(onSubmit)} >
                    {/* <div className="form-hd-lbl">
                      <h3>Profile Information</h3>
                    </div> */}
                    <div className="form-group-wrp">
                      <div className="row">
                        <div className="col name-col">
                          <div className="form-group form-textbox">
                            <input className="form-control form-height" type="text" 
                            defaultValue={data?.results?.first_name} {...register('first_name')} 
                            name="first_name" 
                            id="first_name" 
                            onChange={handleChange}/>
                            <label className="form-lbl form-lbl-profileinfo" htmlFor="first_name">First Name</label>
                          </div>
                          {errors.first_name &&
                            <div className="invalid-feedback">{errors.first_name?.message}</div>
                          }
                        </div>

                        <div className="col" style={{paddingLeft: "0.31rem"}}>
                          <div className="form-group form-textbox">
                            <input className="form-control form-height" type="text" defaultValue={data?.results?.last_name} {...register('last_name')} name="last_name" id="last_name" onChange={handleChange} />
                            <label className="form-lbl form-lbl-profileinfo" htmlFor="last_name">Last Name</label>
                          </div>
                          {errors.last_name &&
                            <div className="invalid-feedback">{errors.last_name?.message}</div>
                          }
                        </div>
                      </div>
                      <div className="form-group form-textbox">
                        <input className="form-control form-height" type="text" defaultValue={data?.results?.mobile} {...register('mobile')} name="mobile" id="mobile" onChange={handleChange}/>
                        <label className="form-lbl form-lbl-profileinfo" htmlFor="mobile">Phone Number</label>
                      </div>
                      {errors.mobile &&
                        <div className="invalid-feedback">{errors.mobile?.message}</div>
                      }
                      {/* <div className="form-group form-textbox">
                        <input className="form-control form-height" type="text" name="email" id="email" defaultValue='' {...register('email')} disabled onChange={handleChange}/>
                        <label className="form-lbl form-lbl-profileinfo" htmlFor="email">Email ID</label>
                      </div>
                      {errors.email &&
                        <div className="invalid-feedback">{errors.email?.message}</div>
                      } */}
                      <div className="form-group form-textbox">
                        <input className="form-control form-height"  type="text" name="notification_email" {...register('notification_email')} defaultValue={data?.results?.notification_email} id="notification_email" onChange={handleChange}/>
                        <label className="form-lbl form-lbl-profileinfo" htmlFor="notification_email">Email ID</label>
                      </div>
                      {errors.notification_email &&
                        <div className="invalid-feedback">{errors.notification_email?.message}</div>
                      }
                      <div className="form-group form-textbox">
                        <textarea className="form-control form-control-textarea form-address" name="address" defaultValue={data?.results?.address}  {...register('address')} id="address" onChange={handleChange}/>
                        <label className="form-lbl form-lbl-profileinfo lbl-address" htmlFor="address">Address</label>
                      </div>
                      {errors.address &&
                        <div className="invalid-feedback">{errors.address?.message}</div>
                      }
                      <div className="location-row" style={{ display: "flex" }}>
                        <div className="zipcode-field" style={{ width: "27%", marginRight: "0.4rem" }}>
                          <div className="form-group form-textbox">
                            <input
                              name='zip_code'
                              className="form-control form-zipcode"
                              type="text"
                              maxLength={5}
                             defaultValue={data?.results?.zip_code}
                              {...register('zip_code', {
                                onChange: (e) => {
                                  onChangeZipCode(e);
                                  handleChange()
                                },
                              })}
                             // onChange={handleChange}
                            />
                            {/* <input className="form-control" type="text" name="country" id="country" {...register('country')} defaultValue={country} hidden /> */}
                            <label className="form-lbl lbl-zipcode" htmlFor="zip_code">Zip Code</label>
                          </div>
                          {/* {zipCodeServiceCheck &&
                        <div className="invalid-feedback">{zipCodeServiceCheck}</div>
                      } */}
                          {errors.zip_code &&
                            <div className="invalid-feedback">{errors.zip_code?.message}</div>
                          }

                        </div>
                        <div className="city-field" style={{ width: "46%", marginRight: "0.4rem" }}>
                          <div className="form-group form-textbox">
                            <input className="form-control form-city" type="text" name="city" id="city" {...register('city')} readOnly 
                             defaultValue={data?.results?.city}
                            ></input>
                            <label className="form-lbl lbl-city" htmlFor="city">City</label>
                          </div>
                          {errors.city &&
                            <div className="invalid-feedback">{errors.city?.message}</div>
                          }
                        </div>
                        <div className="state-field" style={{ width: "27%" }}>
                          <div className="form-group form-textbox">
                            <input
                              className="form-control form-state"
                              type="text"
                              name="state"
                              id="state"
                              defaultValue={data?.results?.state}
                              //value={zipcode}
                              {...register('state')}
                            />
                            <label className="form-lbl lbl-state" htmlFor="state">State</label>
                          </div>
                          {errors.state &&
                            <div className="invalid-feedback">{errors.state?.message}</div>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="form-hd-lbl bikeinfo-hd">
                      <h3>Bike Information</h3>

                    </div>
                    <div className="form-group-wrp">
                      <div className='row' style={{margin: "0rem"}}>
                        <div className='col name-col' style={{marginRight: "0.4rem", padding: "0rem"}}>
                          <div className="form-group">
                            {/* <label className="form-select" htmlFor="biketype">Bike Type</label> */}
                            <Controller
                              name="biketype"
                              // isDisabled={editState}
                              control={control}
                              //value={bikeTypes}
                              defaultValue={bikesTypeId}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    border: state.isFocused ? '#ff7f50' : provided.border,
                                    boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                    '&:hover': {
                                      border: '1px solid #ff7f50',
                                    },
                                  }),

                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: '1rem',
                                    '&:hover': {
                                      backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                      color: state.isSelected ? 'white' : 'black',
                                    },
                                  }),
                                }}
                                  // theme={(theme) => ({
                                  //   ...theme,
                                  //   borderRadius: 0,
                                  //   colors: {
                                  //     ...theme.colors,
                                  //     primary25: '#ffdab9',
                                  //     primary: '#ff7f50',
                                  //   },
                                  // })}
                                  // styles={{
                                  //   control: (baseStyles, state) => ({
                                  //     ...baseStyles,
                                  //     borderColor: state.isFocused ? 'orange' : 'grey',
                                  //     '&:hover': {
                                  //       borderColor: 'orange',
                                  //     },
                                  //   }),  
                                  // }}

                                  // styles={customStylesSelect}
                                  // isClearable
                                  name="biketype"
                                  placeholder="Bike Type"
                                  isSearchable={false}
                                  components={{ DropdownIndicator }}

                                  className="react-dropdown dropdown-type react-custom"
                                  classNamePrefix="dropdown"
                                  // defaultValue={value}
                                  value={value}
                                  options={bikeTypeOptions.map((item, index) =>
                                  ({

                                    value: item?._id,
                                    label: item?.display_name
                                  }))}
                                  // onChange={onChange}
                                  onChange={(selectedOption) => {
                                    //handleResetOptions(selectedOption, value);
                                    onChange(selectedOption);
                                    setInputValueChanges(true);

                                  }}
                                  onInputChange={setBikesTypeId(value.value)}
                                // isOptionSelected={handleResetOptions}

                                />
                              )}
                            />
                          </div>
                          {errors.biketype &&
                            <div className="invalid-feedback">{errors.biketype?.message || errors.biketype?.label.message}</div>
                          }
                        </div>
                        <div className="col name-col">
                          <div className="form-group form-textbox">
                            {/* <label className="form-select" htmlFor="bikemake">Bike Make</label> */}
                            <Controller
                              name="bikemake"
                              //value={bikeMakes}
                              control={control}
                              defaultValue={bikesMakeId}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  name="bikemake"
                                  placeholder="Bike Make"
                                  components={{ DropdownIndicator }}
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      border: state.isFocused ? '#ff7f50' : provided.border,
                                      boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                      '&:hover': {
                                        border: '1px solid #ff7f50',
                                      },
                                    }),
  
                                    option: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                      color: state.isSelected ? 'white' : 'black',
                                      fontSize: '1rem',
                                      '&:hover': {
                                        backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                        color: state.isSelected ? 'white' : 'black',
                                      },
                                    }),
                                  }}
                                  isSearchable={true}
                                  className="react-dropdown react-custom"
                                  classNamePrefix="dropdown"
                                  // defaultValue={value}
                                  value={value}
                                  options={bikeMakeList.map((item, index) => ({
                                    value: item?._id,
                                    label: item?.display_name
                                  }))}
                                  // onChange={onChange}
                                  onChange={(selectedOption) => {
                                    //handleModelReset(selectedOption, value);
                                    onChange(selectedOption);
                                    setInputValueChanges(true);
                                  }}
                                  onInputChange={setBikesMakeId(value.value)}
                                // isOptionSelected={handleModelReset}


                                />
                              )}
                            />
                          </div>
                          {errors.bikemake &&
                            <div className="invalid-feedback">{errors.bikemake?.message || errors.bikemake?.label.message}</div>
                          }
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="form-group model-select">
                            {/* <label className="form-select" htmlFor="bikemodel">Bike Model</label> */}
                            <Controller
                              name="bikemodel"
                              // value={bikeModels}
                              control={control}
                              defaultValue={bikesGearId}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  name="bikemodel"
                                  placeholder="Gear Type"
                                  components={{ DropdownIndicator }}
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      border: state.isFocused ? '#ff7f50' : provided.border,
                                      boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                      '&:hover': {
                                        border: '1px solid #ff7f50',
                                      },
                                    }),
  
                                    option: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                      color: state.isSelected ? 'white' : 'black',
                                      fontSize: '1rem',
                                      '&:hover': {
                                        backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                        color: state.isSelected ? 'white' : 'black',
                                      },
                                    }),
                                  }}
                                  // styles={customStylesSelect}
                                  // defaultValue = {
                                  //   modelOptions.filter(option => option.value === bikemodel)
                                  // }
                                  // isClearable
                                  // isDisabled={editState}
                                  isSearchable={false}
                                  className="react-dropdown dropdown-model react-custom"
                                  classNamePrefix="dropdown"
                                  // defaultValue={value}
                                  value={value}
                                  options={bikeModelList.map((item, index) => ({
                                    value: item?._id,
                                    label: item?.display_name
                                  }))}
                                  onChange={(selectedOption) => {
                                    //handleModelReset(selectedOption, value);
                                    onChange(selectedOption);
                                    setInputValueChanges(true);
                                  }}
                                  onInputChange={
                                    // setBikeModels(value)
                                    setBikesGearId(value.value)
                                  }
                                />
                              )}
                            />
                          </div>
                          {errors.bikemodel &&
                            <div className="invalid-feedback">{errors.bikemodel?.message || errors.bikemodel?.label.message}</div>
                          }
                        </div>
                      </div>



                      {/* {(data?.results?.card?.id) &&
                          <Fragment>

                            <div className="form-hd-lbl card-infop custom-card-style">
                              <h3>Card Information
                                <Icon path={mdiCreditCardEdit} size={1} style={{ position: 'absolute', right: 0, marginRight: 15 }} onClick={handleCardEdit} />
                              </h3>
                            </div>

                            <div className='row custom-row'>
                              <div className="col">
                                <div className='form-group'>
                                  <div className='div-card'>
                                    <p className='crd-num'> Card Number: <span className="card-num-span"> <span className='card-hidden'>XXXX XXXX XXXX</span> {data?.results?.card?.last4}</span></p>
                                    <p className='crd-exmonth'> Expiry Date: <span className="card-expiry-span">{(data?.results?.card?.exp_month) >= 10 ? data?.results?.card?.exp_month : "0" + data?.results?.card?.exp_month} / {data?.results?.card?.exp_year}</span></p>
                                    <p className='crd-type'>Card Type: <span className="card-brand-span">{data?.results?.card?.brand}</span> </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        } */}
                      <Fragment>

                        <div className="form-hd-lbl cardinfo-hd card-infop custom-card-style">
                          <h3>Card Information
                            <Icon className='credit-card' path={mdiCreditCardEdit} size={1} style={{ position: 'absolute', right: 0, marginRight: 15 }} onClick={handleCardEdit} />
                          </h3>
                          {cardFieldEmpty && !data?.results?.card && (
                            <p className="card-info-validation-error" style={{ color: "#e00a23", fontSize: 12, paddingTop: 5 }}>{cardFieldEmpty}</p>
                          )}
                        </div>
                        {data?.results?.card && (
                          <div className='row custom-row'>
                            <div className="col">
                              <div className='form-group'>
                                <div className='div-card'>
                                  <p className='crd-num'> Card Number: <span className="card-num-span"> <span className='card-hidden'>XXXX XXXX XXXX</span> {data?.results?.card?.last4}</span></p>
                                  <p className='crd-exmonth'> Expiration Date: <span className="card-expiry-span">{(data?.results?.card?.exp_month) >= 10 ? data?.results?.card?.exp_month : "0" + data?.results?.card?.exp_month} / {data?.results?.card?.exp_year}</span></p>
                                  <p className='crd-type'>Card Type: <span className="card-brand-span">{data?.results?.card?.brand}</span> </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                      </Fragment>

                      <div className="form-btn-save">
                        {/* {(data?.results?.card?.id) ?
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <button className="btn btn-primary" type='submit' style={{ width: 290 }}> Update </button>
                          <button className="btn btn-primary" type='submit' style={{ width: 290 }}> Continue </button>
                        </div>
                      ) : */}
                        <button className="btn btn-primary btn-update" onClick={handleSaveButtonClick}> Save </button>
                        {/* } */}
                      </div>
                    </div>

                  </form>
                </section>
              </div>
              :
              <div className='nonverify'>
                <Icon path={mdiEmailMarkAsUnread} size={'80px'} color="#ff5f07" />
                <p className='nonverify-cnt'>Please verify your Email ID. Once email has verified then will be add your profile information.</p>
              </div>
            }
          </div>
        </div>
      
      <Footer />
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
       <button >close</button> */}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              {profileInfoSuccess && <span className='success' style={{ marginTop: 15, color: 'white' }}> Profile updated. </span>}
              {(data?.results?.card) ?
                <Fragment>
                  {/* {paymentMethods?.map((paymentdetails) => ( */}
                  <div className='crd-details'>

                    {/* <div className='crd-details' key={paymentdetails}> */}
                    <div className='crd-name'>
                      <p>{data?.results?.card?.brand}</p>
                    </div>
                    <div className='crd-info'>
                      <p className='crd-num'>XXXX XXXX XXXX <span>{data?.results?.card?.last4}</span></p>
                      <div className='crd-expde'>
                        <p className='crd-exmonth'>Expiry Month: <span>{data?.results?.card?.exp_month}</span></p>
                        <p className='crd-exyear'>Expiry Year: <span>{data?.results?.card?.exp_year}</span></p>
                      </div>
                    </div>
                  </div>
                  {/* ))} */}
                </Fragment>
                :
                <Fragment>
                  <>
                    {/* {console.log("key inside fragment", stripeApiKey)} */}
                    {stripeApiKey && (
                      <Elements stripe={stripePromise}>
                        <div className="paymenthdtxt">
                          <h3>Card Information</h3>
                        </div>
                        <CheckoutForm
                          props={props}
                          data={data}
                          setCardFieldEmpty={setCardFieldEmpty}
                          setData={setData}
                          profileInfoSuccess={profileInfoSuccess}
                          setIsOpen={setIsOpen}
                          location={location}
                        />
                      </Elements>
                    )}
                  </>
                </Fragment>
              }
            </div>
          </div>
        </div>
      </Modal>

      {/* <Modal
        isOpen={editIsOpen}
        onRequestClose={closeEditModal}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
       <button >close</button> /}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeEditModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              {/* <p> Profile updated successfully</p> /}
              {console.log('stripeApiKey: inside fragment', stripeApiKey)}

              <Fragment>
                {stripeApiKey && (
                  <Elements stripe={stripePromise}>
                    <div className="paymenthdtxt">
                      <h3>Card Information</h3>
                    </div>

                    <CheckoutForm
                      props={props}
                      data={data}
                      setData={setData}
                      setIsOpen={setIsOpen}
                      profileInfoSuccess={profileInfoSuccess}

                      setEditIsOpen={setEditIsOpen}
                    />
                  </Elements>
                )}
              </Fragment>

            </div>
          </div>
        </div>
      </Modal> */}
      <Modal
        isOpen={editIsOpen}
        onRequestClose={closeEditModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
               <button >close</button> */}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeEditModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              {/* <p> Profile updated successfully</p> */}
              {/* {console.log('stripeApiKey: inside fragment', stripeApiKey)} */}

              <Fragment>
                {/* {stripeApiKey && ( */}
                <Elements stripe={stripePromise}>
                  <div className="paymenthdtxt">
                    <h3>Card Information</h3>
                  </div>

                  <CheckoutForm
                    props={props}
                    // data={data}
                    setData={setData}
                    setIsOpen={setIsOpen}
                    // profileInfoSuccess={profileInfoSuccess}
                    card={handlecard}
                    setEditIsOpen={setEditIsOpen}
                  />
                </Elements>
                {/* )} */}
              </Fragment>

            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={zipcodePopUp}
        onRequestClose={closeModelZipcode}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
       <button >close</button> */}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeModelZipcode}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage' style={{fontSize: "1.2rem"}}>Enter a Valid Zipcode.</p>
            </div>
          </div>
        </div>
        <div className='ok-button' style={{ width: "4.5rem", margin: "0 auto" }}>
          <button className="btn btn-primary btn-update-ok" onClick={closeModelZipcode}> OK </button>
        </div>
      </Modal>

      {profileInfoSuccess && (
        <Modal
        isOpen={updateModelIsOpen}
        onRequestClose={handleCloseModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                {/* <div className='reg-close' onClick={handleCloseModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div> */}
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage'>Profile Updated Successfully.</p>
            </div>
          </div>
        </div>
        <div className='ok-button' style={{ width: "4.5rem", margin: "0 auto" }}>
          <button className="btn btn-primary btn-update-ok" onClick={handleUpdateButton}> OK </button>
        </div>
      </Modal>
      )}

      {inputValueChanges && (
        <Modal
        isOpen={showUnsavedModal}
        onRequestClose={handleUnsavedClose}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
        >

          <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={handleUnsavedClose}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage'>You have not saved your changes. Are you sure?</p>
            </div>
          </div>
        </div>

        <div className='modal-prmt-btns'>
          <div>
            <button className='btn btn-primary cancel-btn' onClick={handleUnsavedClose}>Cancel</button>
          </div>
          <div>
          <button className='btn btn-primary cancel-btn' onClick={handleLeaveButtonClick}>Leave</button>

          </div>

          </div>

        </Modal>
      )}


    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileInfo);